{
  "#AI_TABLE_EXTRACTOR": {
    "TITLE": "Document Reader",
    "UPLOAD_PAGE_TITLE": "Upload document",
    "UPLOAD_PDF_ONLY": "Only PDF files are supported.",
    "UPLOAD_OPEN_DIALOG": "Choose PDF",
    "UPLOAD_DROP_HINT": "Drag a PDF here",
    "UPLOADING": "Uploading document …",
    "UPLOAD_FAILED": "Upload failed",
    "REVIEW_PAGE_TITLE": "Review document",
    "PROCESSING_MODEL_HINT": "The first run can take longer – models are being loaded.",
    "PROCESSING_STEP": {
      "READING": "Reading the document",
      "RECOGNIZING": "Recognizing positions",
      "CHECKING": "Checking amounts",
      "MATCHING": "Matching document data",
      "PREPARING": "Preparing the result",
      "ALMOST": "Almost done",
      "TEMPLATE": "Applying the supplier template"
    },
    "PROCESSING_FAILED": "Processing failed",
    "ERROR_TIMEOUT": "Processing timed out.",
    "ERROR_UNSUPPORTED_VERSION": "Incompatible extraction service version.",
    "BACK_TO_UPLOAD": "Upload a new document",
    "IMPORT_NEW_PDF": "Upload new PDF",
    "TRANSFER": {
      "LABEL": "Transfer items",
      "CHOOSE_TITLE": "Transfer items",
      "CREATE": "Create new document",
      "APPEND": "Add to existing document",
      "APPENDED": "{{n}} position(s) added to {{document}}."
    },
    "CREATE_RECEIPT_WIZARD_TITLE": "Create document",
    "CREATE_RECEIPT_ITEMS_FAILED": "{{failed}} of {{total}} positions could not be transferred.",
    "CREATE_RECEIPT_CUSTOMIZATION_FAILED": "The document text could not be transferred for {{n}} position(s).",
    "CREATE_RECEIPT_NOT_CUSTOMIZABLE": "Product {{key}} is not a manual product – the document text could not be transferred.",
    "CREATE_RECEIPT_PRICES_FAILED": "The price could not be transferred for {{n}} position(s).",
    "CREATE_RECEIPT_UNITS_FAILED": "The Softline unit could not be set for {{n}} position(s).",
    "CREATE_RECEIPT_DISCOUNTS_FAILED": "The markup could not be transferred as a discount for {{n}} position(s).",
    "SUPPLIER": {
      "LABEL": "SOFTLINE supplier",
      "DETECTED_AS": "Detected as {{company}}",
      "NUMBER": "Supplier no. {{n}}",
      "RESOLVING": "Looking up the Softline supplier …",
      "UNRESOLVED": "No Softline supplier assigned",
      "PROFILE_READY": "DTI profile",
      "PROFILE_MISSING": "No DTI profile",
      "PICK_PLACEHOLDER": "Choose supplier …"
    },
    "NO_RESULT_YET": "No result yet",
    "POSITIONS_RECOGNIZED": "Recognized positions",
    "POSITIONS_TAB": "Positions",
    "METADATA_TAB": "Document data",
    "SALES_TAB": "Sales",
    "SALES_PREVIEW": {
      "ARTICLE": "Softline product",
      "TEXT_POSITION": "Text position",
      "LEGEND": "Matched products are transferred as product positions, manual and unassigned positions as the supplier's manual product carrying the document text.",
      "LEGEND_TEXT": "Without a DTI profile for the supplier, unassigned positions are transferred as text positions.",
      "QUANTITY_INVALID": "No valid quantity — the position is created with quantity 1.",
      "UNDECIDED_AS_MANUAL": "→ manual product",
      "UNDECIDED_AS_TEXT": "→ text position"
    },
    "MATCH": {
      "LABEL": "SOFTLINE product",
      "MATCHED": "Matched",
      "SUGGESTED": "Suggestion",
      "MANUAL": "Manual product",
      "UNDECIDED": "Unassigned",
      "PENDING": "Searching product …",
      "CONFIRM": "Accept",
      "ASSIGN": "Assign",
      "CHANGE": "Change",
      "CLEAR": "Remove assignment",
      "UNDECIDED_HINT_MANUAL": "Unassigned — transferred as the supplier's manual product.",
      "UNDECIDED_HINT_TEXT": "Unassigned — transferred as a text position.",
      "MANUAL_HINT": "Created on the supplier's manual product, carrying the document text.",
      "TEXT": "Text position",
      "TEXT_HINT": "Created as a text position carrying the document text – no product, quantity or price.",
      "MATCH_ALL": "Match products",
      "SEARCH_FAILED": "{{n}} position(s) could not be searched.",
      "VIA": {
        "EAN": "found via EAN",
        "SUPPLIER_NUMBER": "found via supplier art. no.",
        "KEY": "found via article no.",
        "NAME": "found via description",
        "MANUAL": "assigned manually"
      }
    },
    "ASSIGN": {
      "TITLE": "Assign position",
      "CANDIDATES": "Softline products",
      "NO_CANDIDATES": "No matching product found — search for one or transfer the row without a product.",
      "SEARCH_PLACEHOLDER": "Search product …",
      "SUPPLIER_NUMBER": "Supplier art. no. {{n}}",
      "MANUAL_SECTION": "Manual product",
      "MANUAL_OPTION": "Transfer as manual product",
      "MANUAL_OPTION_HINT": "The position is created on the supplier's manual product and carries the document text.",
      "TEXT_SECTION": "Text position",
      "TEXT_OPTION": "Transfer as text position",
      "TEXT_OPTION_HINT": "No DTI profile with a manual product – the position is created as a text position carrying the document text, without product, quantity or price.",
      "APPLY": "Assign",
      "CANCEL": "Cancel"
    },
    "UNDECIDED": {
      "TITLE": "Unassigned positions",
      "INTRO_MANUAL": "{{n}} position(s) are not assigned to a product. Transfer them all as the supplier's manual product – or go back to assign them.",
      "INTRO_TEXT": "{{n}} position(s) are not assigned to a product. Transfer them all as text positions – or go back to assign them.",
      "SUGGESTIONS_DROPPED": "Suggestions are discarded by this – to take a suggestion, go back and accept it.",
      "TAKE_ALL_MANUAL": "Transfer all as manual product",
      "TAKE_ALL_TEXT": "Transfer all as text positions",
      "BACK": "Back"
    },
    "ADD_TO_DOCUMENT": {
      "TITLE": "Add to existing document",
      "NUMBER": "Document number",
      "NUMBER_PLACEHOLDER": "e.g. 4711",
      "SEARCH": "Search",
      "INVALID_NUMBER": "Please enter a document number (digits only).",
      "NOT_FOUND": "No document with number {{n}} found.",
      "SEVERAL": "Several documents with number {{n}} – please choose.",
      "READ_ONLY": "{{document}} is finalized and can no longer be changed.",
      "READ_ONLY_BADGE": "finalized",
      "LOOKUP_FAILED": "The document could not be loaded.",
      "CUSTOMER": "Customer",
      "DATE": "Document date",
      "ADD": "Add {{n}} position(s)",
      "CANCEL": "Cancel"
    },
    "CREATE_OPTIONS": {
      "TITLE": "Create document – prices",
      "TITLE_APPEND": "Add positions – prices",
      "PRICE_SOURCE": "Price source",
      "PRICE_DOCUMENT": "Supplier price + markup",
      "PRICE_BACKEND": "VerkaufsWEB price determination",
      "PRICE_DOCUMENT_HINT": "The unit price from the document is raised by the markup and fixed on the position.",
      "PRICE_BACKEND_HINT": "Matched products are priced by sales; manual products still get the document price plus markup.",
      "MARKUP": "Markup (%)",
      "MARKUP_INVALID": "Please enter a percentage (e.g. 15 or -5).",
      "MARKUP_DISCOUNT_HINT": "The markup is written into the \"{{column}}\" column as a negative discount — the unit price stays the document price.",
      "MARKUP_ROW": "Markup %",
      "MARKUP_RESET": "Reset to the general markup",
      "POSITIONS": "Positions",
      "DOCUMENT_PRICE": "Document unit price",
      "SALES_PRICE": "Sales price",
      "BACKEND_PRICED": "Price determination",
      "NO_PRICE": "—",
      "NO_DOCUMENT_PRICE": "No readable unit price on the document — the position is created without a price.",
      "NO_DOCUMENT_PRICE_SHORT": "no price",
      "UNIT_MAPPED": "Document unit {{unit}} is created as {{target}}",
      "UNDECIDED_MANUAL": "{{n}} unassigned position(s) are transferred as the manual product.",
      "UNDECIDED_TEXT": "{{n}} unassigned position(s) are transferred as text positions.",
      "CONTINUE": "Continue",
      "CANCEL": "Cancel"
    },
    "ADD_POSITION": "+ Add position",
    "KEYBOARD_HINT": "↑ ↓ switch position (↓ at the end: new position) · Enter opens · Z assigns · Del removes · ← → switch tab",
    "DELETE_POSITION": "Remove",
    "DELETE_POSITION_WITH_CHILDREN": "Remove with sub-positions",
    "ADD_SUB_POSITION": "+ Sub-position",
    "INDENT": "Indent",
    "OUTDENT": "Outdent",
    "SUB_POSITIONS_COUNT": "{{n}} sub-pos.",
    "SHOW_SUB_POSITIONS": "Show sub-positions",
    "HIDE_SUB_POSITIONS": "Hide sub-positions",
    "DELETE_SELECTED": "Remove selection",
    "DELETE": {
      "TITLE": "Remove positions",
      "QUESTION": "Really remove {{n}} position(s)?"
    },
    "NO_POSITIONS": "No positions recognized.",
    "POSITION_SHORT": "Pos.",
    "EXPAND_POSITION": "Show details",
    "COLLAPSE_POSITION": "Hide details",
    "SELECT_POSITION": "Select position",
    "MARK_HINT": "Mark an area in the PDF — drag a box over the value.",
    "MARK_ASSIGNED": "Assigned: {{text}}",
    "MARK_CANCEL": "Cancel",
    "MARK_BANNER": "Draw a frame for “{{field}}” on the PDF",
    "MARK_BANNER_GENERIC": "Draw a frame on the PDF",
    "TOTALS_NET": "Net total",
    "TOTALS_VAT": "VAT total",
    "TOTALS_GROSS": "Invoice amount",
    "PLAUSIBILITY": {
      "TITLE": "Plausibility check",
      "CHECK": "Plausibility check",
      "SUMMARY_OK": "All checks passed.",
      "SUMMARY_FAILED": "{{n}} check(s) do not add up.",
      "SUMMARY_NOT_CHECKABLE_SUFFIX": " ({{n}} not checkable)",
      "SUMMARY_NOT_CHECKABLE": "No mismatch, but {{n}} check(s) not checkable (values missing).",
      "ADD_SPECIAL_POSITION": "+ Add special position",
      "SPECIAL_POSITION": "Special position",
      "SPECIAL_POSITION_ADDED": "Special position ({{net}} €) added."
    },
    "JSON": {
      "TITLE": "Final JSON",
      "SHOW": "JSON",
      "COPY": "Copy",
      "COPIED": "JSON copied to the clipboard.",
      "COPY_FAILED": "Copying not possible."
    },
    "STATE": {
      "ARITHMETIC_MISMATCH": "Arithmetic mismatch",
      "DISCOUNT_UNPROVEN": "Discount unproven"
    },
    "FIELD": {
      "ITEM_NUMBER": "Pos. no.",
      "PRODUCT_NUMBER": "Product no.",
      "EAN": "EAN",
      "DESCRIPTION": "Description",
      "QUANTITY": "Quantity",
      "UNIT": "Unit",
      "UNIT_PRICE": "Unit price",
      "NET": "Net",
      "VAT_RATE": "VAT rate",
      "DISCOUNT": "Discount"
    },
    "PLACEHOLDER": {
      "ITEM_NUMBER": "e.g. 1",
      "PRODUCT_NUMBER": "Supplier's product number",
      "EAN": "13-digit number",
      "DESCRIPTION": "Description as on the document",
      "QUANTITY": "e.g. 12",
      "UNIT": "e.g. pcs",
      "UNIT_PRICE": "0.00",
      "NET": "0.00",
      "VAT_RATE": "e.g. 20",
      "DISCOUNT": "e.g. 10 %"
    },
    "PDF": {
      "PAGE_PREV": "Previous page",
      "PAGE_NEXT": "Next page",
      "ZOOM_OUT": "Zoom out",
      "ZOOM_IN": "Zoom in",
      "FIT_WIDTH": "Fit to width",
      "ZOOM_RESET": "Actual size (100 %)",
      "META": {
        "TOGGLE": "Show/hide document data",
        "SUPPLIER": "Supplier",
        "RECEIPT_NUMBER": "Document number",
        "RECEIPT_DATE": "Document date",
        "DOCUMENT_TYPE": "Document type",
        "PAGES": "Pages"
      }
    },
    "DOCUMENT_TYPE": {
      "RECHNUNG": "Invoice",
      "ANGEBOT": "Quotation",
      "GUTSCHRIFT": "Credit note",
      "LIEFERSCHEIN": "Delivery note"
    },
    "EXTRACTION_METHOD": {
      "TEMPLATE": "Supplier template applied",
      "PIPELINE": "AI pipeline"
    },
    "META": {
      "ADD_FIELD": "+ Add field",
      "KEYBOARD_HINT": "↑ ↓ switch field · ← → switch tab",
      "CATEGORY_PLACEHOLDER": "Choose field …",
      "CATEGORY": {
        "CASH_DISCOUNT1": "Cash discount 1 rate",
        "DAYS1": "Cash discount 1 term",
        "CASH_DISCOUNT2": "Cash discount 2 rate",
        "DAYS2": "Cash discount 2 term"
      },
      "SUPPLIER": {
        "TITLE": "Supplier",
        "NAME": "Name",
        "ADDRESS": "Address",
        "UID": "VAT ID",
        "GLN": "GLN"
      },
      "RECIPIENT": {
        "TITLE": "Recipient",
        "ADDRESS_BILLING": "Billing address",
        "GLN_BILLING": "Billing GLN",
        "ADDRESS_DELIVERY": "Delivery address",
        "GLN_DELIVERY": "Delivery GLN"
      },
      "RECEIPT": {
        "TITLE": "Document",
        "RECEIPT_NUMBER": "Document number",
        "RECEIPT_DATE": "Document date",
        "VALID_UNTIL": "Valid until",
        "CUSTOMER_NUMBER": "Customer number",
        "PROJECT_NAME": "Project",
        "BILLING_PERIOD": "Billing period",
        "DELIVERY_NOTE_NUMBER": "Delivery note number",
        "NET_DAYS": "Payment term (days)"
      },
      "TOTALS": {
        "TITLE": "Totals",
        "NET": "Net",
        "VAT_RATE": "VAT rate (%)",
        "VAT": "VAT amount",
        "GROSS": "Gross",
        "CURRENCY": "Currency"
      },
      "ADJUSTMENT": {
        "CASH_DISCOUNT_RATE": "Cash discount {{n}} rate",
        "CASH_DISCOUNT_DAYS": "Cash discount {{n}} term",
        "INTEREST_RATE": "Interest {{n}} rate",
        "INTEREST_DAYS": "Interest {{n}} period",
        "SURCHARGE": "Surcharge {{n}}",
        "DISCOUNT": "Discount {{n}}",
        "RETENTION": "Retention/down payment {{n}}",
        "UNPROVEN": "(unproven)"
      }
    }
  }
}
